import useResetPassword from './useResetPassword';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import Container from '@/components/Container';
import Button from '@/components/Button';
import { Link } from 'react-router-dom';
import Loading from '../login/loading.skeleton';

const ForgotPassword = () => {
  const { forgotPasswordPage, handleSubmitForgotPassword, registerForgotPassword, isLoading } = useResetPassword();

  if (!forgotPasswordPage) return <Loading />;

  return (
    <Container className="h-full">
      <div className="col-span-12 flex items-center justify-center">
        <div className="flex max-h-[90vh] w-full max-w-[500px] flex-col items-start overflow-auto rounded-2xl bg-white p-8 shadow-light-purple">
          <img
            className="mb-11 w-[265px] self-center"
            src={forgotPasswordPage?.pageImage.data?.attributes?.url}
            alt={forgotPasswordPage?.pageImage.data?.attributes?.alternativeText || 'Logo'}
          />
          <div className=" flex w-full flex-col items-start">
            <h2 className=" mb-4 text-center font-cadiz text-sh-28-32 font-bold leading-9 tracking-tight text-gray-900">
              {forgotPasswordPage?.forgotPasswordTitle}
            </h2>

            <p className=" mb-4 font-cadiz text-sh-xs">{forgotPasswordPage?.forgotPasswordDescription}</p>

            <form onSubmit={handleSubmitForgotPassword} className="w-full">
              <div className=" mb-8 w-full">
                <Label>
                  <p className="mb-2 text-sh-xs">{forgotPasswordPage?.customerEmailAddressTitle}</p>
                </Label>
                <Input
                  placeholder={forgotPasswordPage?.customerEmailAddressTitle}
                  type="email"
                  {...registerForgotPassword('email')}
                />
              </div>

              <Button type="submit" theme="solid" className="mb-4" loading={isLoading}>
                {forgotPasswordPage?.sendMeCta}
              </Button>
            </form>

            <Link className=" font-cadiz text-sh-xxs underline hover:text-[#1775E3]" to="/login">
              {forgotPasswordPage?.backToLoginCta}
            </Link>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ForgotPassword;
